import { render, staticRenderFns } from "./WMSBallStep.vue?vue&type=template&id=32f5496c&scoped=true"
import script from "./WMSBallStep.vue?vue&type=script&lang=js"
export * from "./WMSBallStep.vue?vue&type=script&lang=js"
import style0 from "./WMSBallStep.vue?vue&type=style&index=0&id=32f5496c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5496c",
  null
  
)

export default component.exports